import { useEffect, useState } from 'react';

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 1279.9);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1279.9);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return ({
    isMobile
    }
);};
